import { render, staticRenderFns } from "./status-price.vue?vue&type=template&id=aed730c2&scoped=true"
import script from "./status-price.vue?vue&type=script&lang=js"
export * from "./status-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed730c2",
  null
  
)

export default component.exports